import type {
	AddStripeSchoolAdminResponse,
	RemoveStripeSchoolAdminResponse,
	ResendStripeSchoolAdminResponse,
	StripeSchoolAdminsResponse,
} from '@kimuno/api-sdk';

import type { AsyncAction } from './common.actionTypes';

// SUB-265: the Admins tab of the Stripe school dashboard. Kept deliberately
// separate from the legacy `GET_SCHOOL_ADMINS` action types (user.actionTypes)
// so the two panels never share state — the stripeSchoolTeachers precedent.

export enum GET_STRIPE_SCHOOL_ADMINS {
	START = 'GET_STRIPE_SCHOOL_ADMINS_START',
	SUCCESS = 'GET_STRIPE_SCHOOL_ADMINS_SUCCESS',
	ERROR = 'GET_STRIPE_SCHOOL_ADMINS_ERROR',
}

export type GetStripeSchoolAdminsAction = AsyncAction<
	typeof GET_STRIPE_SCHOOL_ADMINS.START,
	typeof GET_STRIPE_SCHOOL_ADMINS.SUCCESS,
	typeof GET_STRIPE_SCHOOL_ADMINS.ERROR,
	StripeSchoolAdminsResponse
>;

// The add mutation keeps no reducer state — the dialog branches on the
// returned action and the tab refetches the list.
export enum INVITE_STRIPE_SCHOOL_ADMIN {
	START = 'INVITE_STRIPE_SCHOOL_ADMIN_START',
	SUCCESS = 'INVITE_STRIPE_SCHOOL_ADMIN_SUCCESS',
	ERROR = 'INVITE_STRIPE_SCHOOL_ADMIN_ERROR',
}

export type InviteStripeSchoolAdminAction = AsyncAction<
	typeof INVITE_STRIPE_SCHOOL_ADMIN.START,
	typeof INVITE_STRIPE_SCHOOL_ADMIN.SUCCESS,
	typeof INVITE_STRIPE_SCHOOL_ADMIN.ERROR,
	AddStripeSchoolAdminResponse
>;

// The resend mutation keeps no reducer state either — unlike the teachers tab
// (whose resend re-posts the invite) admins have a dedicated endpoint, since
// the row action shouldn't need the admin's name fields.
export enum RESEND_STRIPE_SCHOOL_ADMIN_INVITE {
	START = 'RESEND_STRIPE_SCHOOL_ADMIN_INVITE_START',
	SUCCESS = 'RESEND_STRIPE_SCHOOL_ADMIN_INVITE_SUCCESS',
	ERROR = 'RESEND_STRIPE_SCHOOL_ADMIN_INVITE_ERROR',
}

export type ResendStripeSchoolAdminInviteAction = AsyncAction<
	typeof RESEND_STRIPE_SCHOOL_ADMIN_INVITE.START,
	typeof RESEND_STRIPE_SCHOOL_ADMIN_INVITE.SUCCESS,
	typeof RESEND_STRIPE_SCHOOL_ADMIN_INVITE.ERROR,
	ResendStripeSchoolAdminResponse
>;

// The remove mutation keeps no reducer state either — the dialog branches on
// the returned action and the tab refetches the list (the resend precedent).
export enum REMOVE_STRIPE_SCHOOL_ADMIN {
	START = 'REMOVE_STRIPE_SCHOOL_ADMIN_START',
	SUCCESS = 'REMOVE_STRIPE_SCHOOL_ADMIN_SUCCESS',
	ERROR = 'REMOVE_STRIPE_SCHOOL_ADMIN_ERROR',
}

export type RemoveStripeSchoolAdminAction = AsyncAction<
	typeof REMOVE_STRIPE_SCHOOL_ADMIN.START,
	typeof REMOVE_STRIPE_SCHOOL_ADMIN.SUCCESS,
	typeof REMOVE_STRIPE_SCHOOL_ADMIN.ERROR,
	RemoveStripeSchoolAdminResponse
>;

export type StripeSchoolAdminsActionTypes =
	| GetStripeSchoolAdminsAction
	| InviteStripeSchoolAdminAction
	| ResendStripeSchoolAdminInviteAction
	| RemoveStripeSchoolAdminAction;
